module.exports = __webpack_public_path__ + "img/little_girls_8.4f754b76.jpg";